import { StylesConfig } from 'react-select/lib/styles';

export const ReactSelectStyles: StylesConfig = {
  container: (base, state) => ({
    ...base,
    position: 'relative',
    borderRadius: '.125rem',
  }),
  valueContainer: (base, state) => ({
    ...base,
    padding: '1px 1px',
    border: state.isFocused ? '3px solid #ab85ff' : 'none',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? '#f8f8fd' // hover background
      : state.isSelected
      ? '#E0D0FF' // selected item background
      : 'white',
    color: 'black', // text color
    '&:active': {
      backgroundColor: '#a76feb', // active (mouse click) color
    },
  }),
  control: (base, state) => ({
    ...base,
    border: '1px solid #9292a4',
    display: 'block',
    padding: '0rem .25rem',
    minHeight: '30.64px',
    backgroundColor: state.isDisabled ? '#dfdfe4' : 'white',
    borderColor: state.isFocused ? '#ab85ff' : '#ab85ff', // customize colors here
    boxShadow: state.isFocused ? '0 0 0 1px #4400d8' : 'none',
    '&:hover': {
      borderColor: '#ab85ff', // color when hovering
      boxShadow: '0 0 0 1px #4400d8',
    },
  }),
  indicatorsContainer: () => ({
    display: 'none',
  }),
  multiValue: base => ({
    ...base,
    backgroundColor: '#c0a0ff',
    marginLeft: '-.1rem',
    marginRight: '.4rem',
    marginTop: '0px',
    marginBottom: '4px',
    borderRadius: '.125rem',
    position: 'relative',
    top: '2px',
    left: '0px',
  }),
  singleValue: base => ({
    ...base,
    whiteSpace: 'nowrap',
    color: '#1b0052',
    padding: '.125rem .5rem',
    backgroundColor: '#c0a0ff',
    maxWidth: '100%',
    borderRadius: '.125rem',
    display: 'inline-block',
    fontSize: '.75rem',
    marginTop: '4px',
    fontWeight: '600',
    marginLeft: '0',
  }),
  multiValueLabel: () => ({
    display: 'inline-block',
    padding: '.125rem .5rem',
    fontSize: '.75rem',
    color: '#1b0052',
    backgroundColor: '#c0a0ff',
    borderRadius: '.125rem',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontWeight: '600',
    borderRight: '2px solid white',
  }),
  multiValueRemove: () => ({
    color: '#1b0052',
    backgroundColor: '#c0a0ff',
    borderRadius: '.125rem',
    paddingBlockEnd: '.125rem',
    paddingTop: '1px',
    paddingRight: '3px',
    cursor: 'pointer',
    paddingLeft: '3px',
  }),
  input: () => ({
    marginTop: '2px',
    marginBottom: '0px',
    position: 'relative',
    top: '-.5px',
  }),
  placeholder: base => ({
    ...base,
    fontStyle: 'italic',
    position: 'absolute',
    top: '14px',
  }),
};

/**
 * Filters option by value.
 * @param option
 * @param inputValue
 * @constructor
 */
export const SelectorFilterOptions = (option, inputValue) => {
  // eslint-disable-next-line
  inputValue = inputValue.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  return (
    (
      option.label
        .toString()
        .toLowerCase()
        .match(inputValue.toLowerCase().trim()) || []
    ).length > 0
  );
};
